import React, { Component, Fragment } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

// expense.month looks like "April,2026" — parse into a real Date so
// months sort chronologically (newest first) instead of alphabetically.
function parseMonthId(id) {
  const [monthName, year] = String(id).split(",");
  const monthIndex = MONTH_NAMES.indexOf((monthName || "").trim());
  return new Date(parseInt(year, 10) || 0, monthIndex >= 0 ? monthIndex : 0, 1);
}

export class Datatable extends Component {
  render() {
    const { myData, history } = this.props;

    const rows = [...(myData || [])].sort(
      (a, b) => parseMonthId(b.month) - parseMonthId(a.month)
    );

    return (
      <Fragment>
        <div className="sl-table-wrap">
          <table className="table sl-table">
            <thead>
              <tr>
                <th scope="col">Month</th>
                <th scope="col">Total</th>
                <th scope="col" className="sl-col-action">Inspect</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={3} className="sl-empty">
                    No records yet.
                  </td>
                </tr>
              ) : (
                rows.map((expense, i) => (
                  <tr key={i}>
                    <td>{expense.month}</td>
                    <td>
                      <span className="sl-amount-pill">{expense.amount}Tk</span>
                    </td>
                    <td className="sl-col-action">
                      <button
                        type="button"
                        className="sl-icon-btn"
                        onClick={() => {
                          history.push(`/expense/salary/${expense.month}`);
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
